import { render } from "./EmailCards.vue?vue&type=template&id=91706154&ts=true"
import script from "./EmailCards.vue?vue&type=script&lang=ts"
export * from "./EmailCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__